export enum ChaseDocumentPageType {
  Chase = "chaseDocumentPages",
  Member = "memberDocumentPages",
  Diagnosis = "diagnosisDocumentPages",
  Encounter = "encounterDocumentPages",
}
